import { fetchApi } from 'src/_helpers/client/fetchApi'
import { buildUrl } from 'src/_helpers/buildUrl'

const PATH = '/api/open/news'
const TAGS_PATH = '/api/open/news_tags'

async function getPage(page, perPage, order) {
  const url = buildUrl(PATH, { 'order[ord]': order, page, perPage })

  return await fetchApi(url, 'GET', { accept: 'application/ld+json' }, { next: { tags: ['news'] } }).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch entities: ${url}`)
    },
  )
}

async function getJournalPage(journalUuid, page, perPage, order) {
  const url = buildUrl(`/api/open/journal_news/${journalUuid}`, { 'order[ord]': order, page, perPage })

  return await fetchApi(url, 'GET', { accept: 'application/ld+json' }, { next: { tags: ['news'] } }).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch entities: ${url}`)
    },
  )
}

async function getPublisherPage(publisherUuid, page, perPage, order) {
  const url = buildUrl(`/api/open/publisher_news/${publisherUuid}`, { 'order[ord]': order, page, perPage })

  return await fetchApi(url, 'GET', { accept: 'application/ld+json' }, { next: { tags: ['news'] } }).then(
    (response) => response,
    () => {
      throw new Error(`Failed to fetch entities: ${url}`)
    },
  )
}

async function getTagByUuid(uuid) {
  if (!uuid) {
    return null
  }

  const url = `${TAGS_PATH}/${uuid}`

  return await fetchApi(url, 'GET', { accept: 'application/json' }, { next: { tags: [`news_tag:${uuid}`] } }).then(
    (response) => response,
    () => null,
  )
}

async function getTagsByUuids(uuids = []) {
  if (!Array.isArray(uuids) || uuids.length === 0) {
    return []
  }

  const tags = await Promise.all(
    uuids.map(async (uuid) => {
      try {
        return await getTagByUuid(uuid)
      } catch (error) {
        console.error(error)
        return null
      }
    }),
  )

  return tags.filter(Boolean)
}

export const newsService = {
  getPage,
  getJournalPage,
  getPublisherPage,
  getTagsByUuids,
}
